export default __webpack_public_path__ + "static/lunar-celebrations-chinatown-611551920d308f90ee93e067aa7178e2.jpg";